import React, { FC } from 'react'
import { usePaginationFragment, graphql } from 'react-relay'

import {
  Stack,
  GuildCard,
  Grid,
  Column,
  Button,
  Text,
  Card,
  useBreakpoint,
} from '@components'

import { HomeScreenGuildsList_query$key } from './__generated__/HomeScreenGuildsList_query.graphql'

import { INITIAL_COUNTS } from './HomeScreen'

export const HomeScreenGuildsList: FC<{
  query: HomeScreenGuildsList_query$key
}> = ({ query }) => {
  const { data } = usePaginationFragment(
    graphql`
      fragment HomeScreenGuildsList_query on Query
      @refetchable(queryName: "HomeScreenGuildsListPaginationQuery")
      @argumentDefinitions(
        count: { type: "Int!", defaultValue: 4 }
        cursor: { type: "Cursor" }
      ) {
        guilds: rankedGuilds(guildType: GUILD, first: $count, after: $cursor)
          @connection(key: "HomeScreenGuildsList_query_guilds") {
          edges {
            node {
              ...GuildCard_guild
            }

            cursor
          }
        }
      }
    `,
    query
  )

  const breakpoint = useBreakpoint()

  if (breakpoint === 0) {
    return (
      <Stack gap={4}>
        {data.guilds.edges.map((edge) => (
          <GuildCard
            key={edge.cursor}
            guild={edge.node}
            limitDescriptionLines={8}
          />
        ))}
      </Stack>
    )
  }

  return (
    <Stack gap={4}>
      <Stack>
        <Grid gap={4}>
          {data.guilds.edges
            .slice(0, INITIAL_COUNTS[breakpoint])
            .map((edge) => {
              return (
                <Column key={edge.cursor}>
                  <GuildCard
                    guild={edge.node}
                    limitDescriptionLines={8}
                    expand
                  />
                </Column>
              )
            })}

          {Array.from({
            length: INITIAL_COUNTS[breakpoint] - data.guilds.edges.length,
          }).map((_, index) => (
            <Column key={index} />
          ))}
        </Grid>
      </Stack>
    </Stack>
  )
}
